import React from 'react'

import useTranslations from '../../hooks/useTranslations'
import ANTDCard from '../../shared/antd/ANTDCard'
import ANTDImage from '../../shared/antd/ANTDImage'
import {
  Diarrhoea1,
  Diarrhoea2,
  Pneumonia1,
  Pneumonia2,
} from '../../utils/icons'

const FirstAid = () => {
  const { t } = useTranslations()
  return (
    <div>
      <h2>{t('menu_FirstAid')}</h2>
      <div className="d-flex mt-10">
        <div className="w-50" style={{ padding: '24px' }}>
          <h3 className="primary-color">{t('Diarrhoea')}</h3>
          <ANTDCard>
            <ANTDImage src={Diarrhoea1} alt="12" />
            <ANTDImage src={Diarrhoea2} className="mt-20" alt="12" />
          </ANTDCard>
        </div>
        <div className="w-50" style={{ padding: '24px' }}>
          <h3 className="primary-color">{t('Pneumonia')}</h3>
          <ANTDCard>
            <ANTDImage src={Pneumonia1} alt="12" width={'670px'} />
            <ANTDImage src={Pneumonia2} className="mt-10" alt="12" />
          </ANTDCard>
        </div>
      </div>
    </div>
  )
}

export default FirstAid
